// @ts-strict-ignore
import React from 'react'
import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'

const CardContainer = styled.View`
  display: flex;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  border-radius: 5px;
  background-color: ${({ theme, accent }) =>
    accent ? theme.colors.serviceDetailCardAccentBg : theme.colors.serviceDetailCardBg};
`

const TextsContainer = styled.View`
  width: 100%;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

const ServiceDetailCard = ({ item, accent = false }) => {
  const textColor = accent ? 'serviceDetailCardAccentText' : 'serviceDetailCardText'

  return (
    <CardContainer testID="SERVICE_DETAIL" accent={accent}>
      <TextsContainer>
        <Typography variant="subheader" color={textColor}>
          {item.header}
        </Typography>
        <Typography variant="h3" color={textColor}>
          {item.body}
        </Typography>
        <Typography variant="caption" color={textColor}>
          {item.footer}
        </Typography>
      </TextsContainer>
    </CardContainer>
  )
}

export default ServiceDetailCard
